webpackJsonp([110],{

/***/ "FJil":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StopPlaySvc_1 = __webpack_require__("MT/e");
var ScrollButton = (function () {
    ScrollButton.$inject = ["$element", "$rootScope", "ViewPortSvc"];
    function ScrollButton($element, $rootScope, ViewPortSvc) {
        var _this = this;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.ViewPortSvc = ViewPortSvc;
        this.canAnimate = true;
        this.stopPlaySvc = new StopPlaySvc_1.StopPlaySvc($rootScope, ViewPortSvc, $element, function (canAnimate) { return _this.canAnimate = canAnimate; });
    }
    return ScrollButton;
}());
exports.ScrollButton = ScrollButton;
angular.module('animatronApp.scrollButton', []).component('scrollButton', {
    controller: ScrollButton,
    template: '<span class="scroll-button" ng-class="{animate: $ctrl.canAnimate}">{{::$root.t("wv.landing.top.smmw.scroll")}}</span>'
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/110-28dc41a6a889e793a2e2.min.js